export interface ProjectLookupDto {
  application_name: string;
  application_description: string;
  business_unit: string;
  it_function_department: string;
  business_owner?: string | null;
  it_application_owner?: string | null;
  gxp_status: string;
  quality_representative_name: string;
  quality_representative_contact_details: string;
  id: string;
}

export interface ProjectLookup {
  applicationName: string;
  applicationDescription: string;
  businessUnit: string;
  itFunctionDepartment: string;
  businessOwner: string;
  itApplicationOwner: string;
  gxpStatus: string;
  qualityRepresentativeName: string;
  qualityRepresentativeContactDetails: string;
  id: string;
  sensitiveData: boolean | null;
}

export function mapProjectLookup(dto: ProjectLookupDto): ProjectLookup {
  return {
    applicationName: dto.application_name,
    applicationDescription: dto.application_description,
    businessUnit: dto.business_unit,
    itFunctionDepartment: dto.it_function_department,
    businessOwner: dto.business_owner ?? '',
    itApplicationOwner: dto.it_application_owner ?? '',
    gxpStatus: dto.gxp_status,
    qualityRepresentativeName: dto.quality_representative_name,
    qualityRepresentativeContactDetails:
      dto.quality_representative_contact_details,
    id: dto.id,
    sensitiveData: null,
  };
}
